/****** JAVASCRIPT FÜR SIXLAB ******/



/*	MAIN SCRIPTS
	------------------------ */

/* ----- Miniwarenkorb: Artikelmenge aktualiseren nach Seitenaufruf ---------------------------- */

$(document).ready(function() {
  $.getJSON('/cart.js', function(cart) {
    $('.cartCount').html(cart.item_count);
  });
});

/* ----- Mobile Navigation ---------------------------- */

$(document).ready(function() {

	// Variablen definieren

	var header = $('#header');
	var darkOverlay = $('.darkOverlay');
	var mobileNav = $('#mobileNav');
	var iconMobileNav = $('.iconMobileNav');


	// Mobile Navigation ein-/ausblenden

	iconMobileNav.click(function () {
		if (iconMobileNav.hasClass('active')) {
			mobileNav.hide();
			header.css('position','');
			iconMobileNav.removeClass('active');
			darkOverlay.hide();
		}
		else {
			mobileNav.show();
			header.css('position','absolute');
			iconMobileNav.addClass('active');
			darkOverlay.show();
			$('html, body').animate({ scrollTop: 0 }, 'slow');
			return false;
		}
	});


	// Mobile Navigation bei Klick auf Overlay ein-/ausblenden

	darkOverlay.click(function () {
		darkOverlay.hide();
		mobileNav.hide();
		header.css('position','');
		iconMobileNav.removeClass('active');
	});


	// Mobile Navigation - Accordion-Menü

	var mobileMenuAnchor = $('#mobileNav .sub > a');
	var mobileSubMenu = $('#mobileNav .subMenu');

	// Bei Klick auf Reiter
	mobileMenuAnchor.click( function(e) {
		// Normales Linkverhalten deaktivieren
		e.preventDefault();

		// Anzeigen/Verstecken der Reiter
		if ($(this).parent().hasClass('open')) {
			$(this).next().stop(true,true).slideToggle(200);
			mobileMenuAnchor.parent().removeClass('open');
		}
		else {
			mobileSubMenu.slideUp(200);
			$(this).next().stop(true,true).slideToggle(200);
			mobileMenuAnchor.parent().removeClass('open');
			$(this).parent().addClass('open');
		}
	});

});


/* ----- Allgemeines Accordion ---------------------------- */

$(document).ready(function() {

	// Variablen definieren
	var accordionRow = $('.accordion > li');
	var accordionTrigger = $('.accordion > li > .trigger');
	var accordionBody = $('.accordion li > .subContent');

	// Öffne ersten Reiter nach Laden der Seite
	// accordionRow.first().addClass('active').children('.subContent').show();

	// Klick auf Reiter
	accordionTrigger.click( function() {
		// Verstecken/Anzeigen der Reiter bei Klick
		if ($(this).closest('li').attr('class') != 'active') {
			accordionBody.slideUp('fast');
			$(this).next().stop(true,true).slideToggle('fast');
			accordionRow.removeClass('active');
			$(this).closest('li').addClass('active');
		}
	});
});


/* ----- Modal Window ---------------------------- */

$(document).ready(function() {

	// Alle a-Tags mit Attribut data-modal=open auswählen
	$('a[data-modal="open"]').click(function(e) {
		// Normales Linkverhalten deaktivieren
		e.preventDefault();

		// href von a-Tag in Variable speichern
		var id = $(this).attr('href');

		// Modalfenster auf aktuelle Position verschieben
		$('body').css('overflow', 'hidden');
		var windowHeight = $('body').height();
		$('.modalWindow .main').css('min-height', windowHeight-150);

		// Modal-Box einblenden
		$(id).addClass('active');
	});

	// Beim Klick auf schließen-Button
	$('.modalWindow .iconClose').click(function(e) {
		// Normales Linkverhalten deaktivieren
		e.preventDefault();
		$('.modalWindow').removeClass('active');
		$('body').css('overflow', 'auto');
	});

	// Beim Klick auf Overlay
	$('.overlay').click(function () {
		$('.modalWindow').removeClass('active');
		$('body').css('overflow', 'auto');
	});

	// Modal Window mit ESC-Taste schließen

	$(document).keyup(function(e) {
		if(e.keyCode == 27) {
			$('.modalWindow').removeClass('active');
			$('body').css('overflow', 'auto');
		}
	});

});


/* ----- Select	DropDown ---------------------------- */

$(document).ready(function() {
	$('.outerSelect select').change(function() {
		var selectedOption = $(this).find('option:selected');

		$(this).parent().children('span').text( selectedOption.text() );
	});
});


/* ----- iOS Hover Fix ---------------------------- */

var iOSHover = function () {
	$('*').on('touchstart', function () {
		$(this).trigger('hover');
	}).on('touchend', function () {
		$(this).trigger('hover');
	});
};

iOSHover();


/*	STARTSEITE
	------------------------ */

/* ----- SwipeJs - Teaser ---------------------------- */

$(document).ready(function() {

	// SwipeJs - Bildergalerie Init
	window.fullWidthTeaser = new Swipe(document.getElementById('fullWidthTeaser'), {
		continuous: true,
		auto: 10000
	});

	// SwipeJs - nächstes/vorheriges Bild
	$('.nextImg').click(function() {
		fullWidthTeaser.next();
	});

	$('.prevImg').click(function() {
		fullWidthTeaser.prev();
	});

});


/*	PRODUKTSEITE
	------------------------ */

/* ----- Produktgalerie ---------------------------- */

$(document).ready(function() {
	// Produktbild (medium) wechseln
	$('.js-smallImage').mouseenter( function() {
		var clickedImgId = $(this).attr('data-image-id');
		var clickedImg = $('.js-smallImage[data-image-id="' + clickedImgId + '"]');
		var clickedSmallImg = $(this).find('img').attr('src');
		var clickedMediumImg = $(this).attr('data-image-medium');
		var galleryId = $(this).attr('data-gallery-id');
		var gallery = $('.js-smallImage[data-gallery-id="' + galleryId + '"]');
		var targetImg = $('.js-mediumImage[data-gallery="' + galleryId + '"]');

		// angefordertes Bild in Cache laden
		var cacheImage = new Image();
		cacheImage.src = clickedMediumImg;

		// Bild austauschen falls Cache-Bild komplett geladen
		$(targetImg).attr('src', clickedSmallImg);

		$(cacheImage).one('load',function() {
			$(targetImg).attr('src', clickedMediumImg);
			$(targetImg).attr('data-image-id', clickedImgId);
			$(gallery).removeClass('active');
			$(clickedImg).addClass('active');			
		}).each(function() {
			if(this.complete) {
				$(this).trigger('load');
			}
		});

	});
});


/* ----- XXL-Gallery ---------------------------- */

$(document).ready(function() {

	// XXL-Galerie einblenden
	$('.js-mediumImage').click( function() {
		var clickedImgId = $(this).attr('data-image-id');
		var clickedMediumImg = $('.js-smallImage[data-image-id="' + clickedImgId + '"]').attr('data-image-medium');
		var clickedLargeImg = $('.js-smallImage[data-image-id="' + clickedImgId + '"]').attr('data-image-large');

		// angefordertes Bild in Cache laden
		var cacheImage = new Image();
		cacheImage.src = clickedLargeImg;

		// Bild austauschen falls Cache-Bild komplett geladen
		$('#xxlGallery img').attr('src', clickedMediumImg);

		// Bild austauschen falls nicht aktiv
		$(cacheImage).one('load',function() {
			$('#xxlGallery img').attr('src', clickedLargeImg);
		}).each(function() {
			if(this.complete) {
				$(this).trigger('load');
			}
		});

		// Produktdetails ausblenden
		$('#page').css('display', 'none');

		// XXL-Gallery anzeigen
		$('#xxlGallery').css('display', 'block');
	});

	// XXL-Gallery ausblenden
	$('#xxlGallery .iconCloseGal').click( function() {
		// XXL-Gallery ausblenden
		$('#xxlGallery').css('display', 'none');

		// Nach oben scrollen
		$(window).scrollTop(0);

		// Produktdetails anzeigen
		$('#page').css('display', 'block');
	});

});


/* ----- Auswahl von Variante ---------------------------- */

$(document).ready(function() {

	// Bei Klick auf Variante
	$('.varList li').click(function() {
		$('.varList li').removeClass('selected');

		// Formular mit Werte füllen
		$('#addToCartForm input[name="id"]').val( $(this).attr('id') );

		// CSS-Klasse hinzufügen
		$(this).addClass('selected');

		// Hinweis (Zuerst Variante wählen) entfernen
		$('#sizeHint').removeClass('visible');

		// Lieferinfos ausblenden wenn Variante ausverkauft ist
		if ( $(this).hasClass('soldout') ) {
			$('.shippingInfo').addClass('hidden');
		}
		else {
			$('.shippingInfo').removeClass('hidden');
		}
	});
});


/* ----- Artikel in den Warenkorb legen ---------------------------- */

$(document).ready( function() {	

	$('#addToCartForm').submit(function(e) {
		// Normale Button-Funktion außer Kraft setzen
		e.preventDefault();

		var id = $('#addToCartForm input[name="id"]').val();
		var quantity = $('#addToCartForm input[name="quantity"]').val();

		// falls noch keine Variante ausgewählt wurde Hinweis zeigen (Zuerst Variante wählen)
		// ansonsten Artikel zum Warenkorb hinzufügen
		if ( $('.varList li').hasClass('selected') ) {
			// Zum Warenkorb hinzufügen
			$.ajax({
				type: 'POST',
				url: '/cart/add.js',
				dataType: 'json',
				data: {id:id,quantity:quantity},
				success: function(){

					// Variantenauswahl löschen
					$('#addToCartForm input[name="id"]').val('');
					$('.varList li').removeClass('selected');

					// Artikelmenge im Miniwarenkorb aktualiseren
					$.getJSON('/cart.js', function(cart) {
						$('.cartCount').html(cart.item_count);
					});
                  
					// Neuer Artikel im Warenkorb - Message ein-/ausblenden
					$('#itemAdded').show();
					$('#itemAdded').delay(2000).hide(0);

				},
				error: function(XMLHttpRequest) {

					// Shopify gibt eine Beschreibung des Errors zurück in XMLHttpRequest.responseText
					// Es ist JSON
					// Beispiel: {"description":"The product 'Amelia - Small' is already sold out.","status":500,"message":"Cart Error"}
					var data = eval('(' + XMLHttpRequest.responseText + ')');
              
					if (!!data.message) {
						// Wenn alle Artikel dieser Variante bereits im Warenkorb liegen
						if (data.status == 422) {
							alert('Die verfügbare Menge in dieser Größe liegt bereits im Warenkorb');
						}
                		else {
							alert(data.message + ' (' + data.status  + ') ' + data.description);
						}
    	            }
					else {
						alert('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.');
            	    }

				}
			});
			return false;
		}
		else {
			$('#sizeHint').addClass('visible');			
		}
	});

});


/*	WARENKORB
	------------------------ */

/* ----- Artikelmenge ändern ---------------------------- */

$(document).ready( function() {	
	$('.js-changeAmount').change( function() {
		$('#btnUpdate').click();
	});
});


/*	ACCOUNT
	------------------------ */

/* ----- Accordion - Deine Bestellungen ---------------------------- */

$(document).ready( function() {

	// alle Bestellungen schließen
	$('.orderHead').not('.active').next('.orderBody').hide();

	// Inhalte anzeigen/verstecken
	$('.orderHead').click( function() {
		var trigger = $(this);

		if ( trigger.hasClass('active') ) {
			return false;
		} else {
			$('.orderHead').removeClass('active');
			$('.orderBody').slideUp('fast');
			trigger.next('.orderBody').slideToggle('fast');
			trigger.addClass('active');
		};
		return false;
	});

});